
import { NgModule } from "@angular/core";
import { MapModule } from "~app/common/components/map/map.module";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { SharedModule } from "../shared/shared.module";
import { SokTransportforetagComponent } from "./components/sok-transportforetag/sok-transportforetag.component";
import { DestineringsomradenComponent } from "./destineringsomraden/destineringsomraden.component";
import { DsoEditComponent } from "./destineringsomraden/dso-edit/dso-edit.component";
import { DsoKartaComponent } from "./destineringsomraden/dso-karta/dso-karta.component";
import { DsoSearchComponent } from "./destineringsomraden/dso-search/dso-search.component";
import { TransportforetagListComponent } from "./transportforetag/transportforetag-list/transportforetag-list.component";
import { TransportforetagRedigeraComponent } from "./transportforetag/transportforetag-redigera/transportforetag-redigera.component";
import { TransportforetagComponent } from "./transportforetag/transportforetag.component";
import { TplArbetsorderInfoModalComponent } from "./transportplanera/components/tpl-arbetsorder-info-modal/tpl-arbetsorder-info-modal.component";
import { TplArbetsorderListComponent } from "./transportplanera/components/tpl-arbetsorder-info-modal/tpl-arbetsorder-list.component";
import {
    TplArbetsordrarDestineringsalternativManuellaComponent
} from "./transportplanera/components/tpl-arbetsordrar-destineringsalternativ-manuella/tpl-arbetsordrar-destineringsalternativ-manuella.component";
import { TplAffarsformFilterComponent } from "./transportplanera/components/tpl-filter/tpl-affarsform-filter/tpl-affarsform-filter.component";
import { TplAnskaffningsformFilterComponent } from "./transportplanera/components/tpl-filter/tpl-anskaffningsform-filter/tpl-anskaffningsform-filter.component";
import { TplAvstandFilterComponent } from "./transportplanera/components/tpl-filter/tpl-avstand-filter/tpl-avstand-filter.component";
import { TplDestineradFilterComponent } from "./transportplanera/components/tpl-filter/tpl-destinerad-filter/tpl-destinerad-filter.component";
import { TplDestineringsomradeFilterComponent } from "./transportplanera/components/tpl-filter/tpl-destineringsomrade-filter/tpl-destineringsomrade-filter.component";
import { TplFilterComponent } from "./transportplanera/components/tpl-filter/tpl-filter.component";
import { TplFritextFilterComponent } from "./transportplanera/components/tpl-filter/tpl-fritext-filter/tpl-fritext-filter.component";
import { TplHandelssortimentFilterComponent } from "./transportplanera/components/tpl-filter/tpl-handelssortiment-filter/tpl-handelssortiment-filter.component";
import { TplLageralderFilterComponent } from "./transportplanera/components/tpl-filter/tpl-lageralder-filter/tpl-lageralder-filter.component";
import { TplMaskinlagFilterComponent } from "./transportplanera/components/tpl-filter/tpl-maskinlag-filter/tpl-maskinlag-filter.component";
import { TplMottagningsplatsFilterComponent } from "./transportplanera/components/tpl-filter/tpl-mottagningsplats-filter/tpl-mottagningsplats-filter.component";
import { TplNasfranvagFilterComponent } from "./transportplanera/components/tpl-filter/tpl-nasfranvag-filter/tpl-nasfranvag-filter.component";
import { TplProduktionsomradeFilterComponent } from "./transportplanera/components/tpl-filter/tpl-produktionsomrade-filter/tpl-produktionsomrade-filter.component";
import { TplProduktionsstatusFilterComponent } from "./transportplanera/components/tpl-filter/tpl-produktionsstatus-filter/tpl-produktionsstatus-filter.component";
import { TplRedovisningshanvisningFilterComponent } from "./transportplanera/components/tpl-filter/tpl-redovisningshanvisning-filter/tpl-redovisningshanvisning-filter.component";
import { TplSkordningstidFilterComponent } from "./transportplanera/components/tpl-filter/tpl-skordningstid-filter/tpl-skordningstid-filter.component";
import { TplSkotningstidFilterComponent } from "./transportplanera/components/tpl-filter/tpl-skotningstid-filter/tpl-skotningstid-filter.component";
import { TplTillganglighetFilterComponent } from "./transportplanera/components/tpl-filter/tpl-tillganglighet-filter/tpl-tillganglighet-filter.component";
import { TplTransportforetagFilterComponent } from "./transportplanera/components/tpl-filter/tpl-transportforetag-filter/tpl-transportforetag-filter.component";
import { TplTransporthandelseFilterComponent } from "./transportplanera/components/tpl-filter/tpl-transporthandelse-filter/tpl-transporthandelse-filter.component";
import { TplTransporttilldeladFilterComponent } from "./transportplanera/components/tpl-filter/tpl-transporttilldelad-filter/tpl-transporttilldelad-filter.component";
import { TplVaglagerFilterComponent } from "./transportplanera/components/tpl-filter/tpl-vaglager-filter/tpl-vaglager-filter.component";
import {
    TplValbaraMottagningsplatserFilterComponent
} from "./transportplanera/components/tpl-filter/tpl-valbara-mottagningsplatser-filter/tpl-valbara-mottagningsplatser-filter.component";
import { TplVolymFilterComponent } from "./transportplanera/components/tpl-filter/tpl-volym-filter/tpl-volym-filter.component";
import { TplHandelserRemoveAoWarningComponent } from "./transportplanera/components/tpl-handelser/tpl-handelser-remove-ao-warning/tpl-handelser-remove-ao-warning.component";
import { TplHandelserComponent } from "./transportplanera/components/tpl-handelser/tpl-handelser.component";
import { TplHanteraAoComponent } from "./transportplanera/components/tpl-hantera-ao/tpl-hantera-ao.component";
import { TplKartaComponent } from "./transportplanera/components/tpl-karta/tpl-karta.component";
import { TplLegendComponent } from "./transportplanera/components/tpl-legend/tpl-legend.component";
import { GaugeChartComponent } from "./transportplanera/components/tpl-mottagningsplats-modal/gauge-chart/gauge-chart.component";
import { TaktChartLegendComponent } from "./transportplanera/components/tpl-mottagningsplats-modal/takt-chart/takt-chart-legend/takt-chart-legend.component";
import { TaktChartComponent } from "./transportplanera/components/tpl-mottagningsplats-modal/takt-chart/takt-chart.component";
import { TplMottagningsplatsModalComponent } from "./transportplanera/components/tpl-mottagningsplats-modal/tpl-mottagningsplats-modal.component";
import {
    BegransaVirkesorderraderModalComponent
} from "./transportplanera/components/tpl-omdestinera/components/begransa-virkesorderrader-modal/begransa-virkesorderrader-modal.component";
import { TplDestineraModalComponent } from "./transportplanera/components/tpl-omdestinera/components/tpl-destinera-modal/tpl-destinera-modal.component";
import { TplWarningModalComponent } from "./transportplanera/components/tpl-omdestinera/components/tpl-warning-modal/tpl-warning-modal.component";
import { TplOmdestineraComponent } from "./transportplanera/components/tpl-omdestinera/tpl-omdestinera.component";
import { TplSearchComponent } from "./transportplanera/components/tpl-search/tpl-search.component";
import {
    TplTransportavstandKartaViapunktDialogComponent
} from "./transportplanera/components/tpl-transportavstand-modal/tpl-transportavstand-karta/dialogs/viapunkt/viapunkt-dialog.component";
import { TplTransportavstandKartaComponent } from "./transportplanera/components/tpl-transportavstand-modal/tpl-transportavstand-karta/tpl-transportavstand-karta.component";
import { TplTransportavstandModalComponent } from "./transportplanera/components/tpl-transportavstand-modal/tpl-transportavstand-modal.component";
import { TplTransportavstandWarningComponent } from "./transportplanera/components/tpl-transportavstand-modal/tpl-transportavstand-warning/tpl-transportavstand-warning.component";
import {
    TplTilldelningWarningModalComponent
} from "./transportplanera/components/tpl-transporttilldelning/components/tpl-tilldelning-warning-modal/tpl-tilldelning-warning-modal.component";
import {
    TplTransporttilldelningAoComponent
} from "./transportplanera/components/tpl-transporttilldelning/components/tpl-transporttilldelning-ao/tpl-transporttilldelning-ao.component";
import {
    TplTransporttilldelningHsComponent
} from "./transportplanera/components/tpl-transporttilldelning/components/tpl-transporttilldelning-hs/tpl-transporttilldelning-hs.component";
import {
    TplTransporttilldelningModalComponent
} from "./transportplanera/components/tpl-transporttilldelning/components/tpl-transporttilldelning-modal/tpl-transporttilldelning-modal.component";
import { TplTransporttilldelningComponent } from "./transportplanera/components/tpl-transporttilldelning/tpl-transporttilldelning.component";
import { TplVolymComponent } from "./transportplanera/components/tpl-volym/tpl-volym.component";
import { TransportplaneraComponent } from "./transportplanera/transportplanera.component";

@NgModule({
    imports: [
        RaskCommonModule,
        MapModule,
        SharedModule,
        TransportplaneraComponent,
        TransportforetagComponent,
        TransportforetagRedigeraComponent,
        TransportforetagListComponent,
        TplKartaComponent,
        TplFilterComponent,
        TplSearchComponent,
        TplTransporttilldelningComponent,
        TplOmdestineraComponent,
        TplLegendComponent,
        TplTransporttilldelningModalComponent,
        TplTilldelningWarningModalComponent,
        TplDestineraModalComponent,
        SokTransportforetagComponent,
        TplTransporttilldelningAoComponent,
        TplTransporttilldelningHsComponent,
        TplArbetsorderInfoModalComponent,
        TplArbetsorderListComponent,
        TplVolymComponent,
        TplWarningModalComponent,
        DestineringsomradenComponent,
        DsoKartaComponent,
        DsoSearchComponent,
        DsoEditComponent,
        TplDestineringsomradeFilterComponent,
        TplVaglagerFilterComponent,
        TplFritextFilterComponent,
        TplTransportforetagFilterComponent,
        TplDestineradFilterComponent,
        TplTransporthandelseFilterComponent,
        TplTransporttilldeladFilterComponent,
        TplLageralderFilterComponent,
        TplMottagningsplatsFilterComponent,
        TplAvstandFilterComponent,
        TplVolymFilterComponent,
        TplHandelssortimentFilterComponent,
        TplMaskinlagFilterComponent,
        TplAnskaffningsformFilterComponent,
        TplTillganglighetFilterComponent,
        TplTransportavstandModalComponent,
        TplTransportavstandKartaComponent,
        TplTransportavstandWarningComponent,
        BegransaVirkesorderraderModalComponent,
        TplSkotningstidFilterComponent,
        TplSkordningstidFilterComponent,
        TplMottagningsplatsModalComponent,
        TaktChartComponent,
        TaktChartLegendComponent,
        GaugeChartComponent,
        TplHandelserComponent,
        TplHandelserRemoveAoWarningComponent,
        TplHanteraAoComponent,
        TplProduktionsstatusFilterComponent,
        TplRedovisningshanvisningFilterComponent,
        TplNasfranvagFilterComponent,
        TplTransportavstandKartaViapunktDialogComponent,
        TplProduktionsomradeFilterComponent,
        TplArbetsordrarDestineringsalternativManuellaComponent,
        TplAffarsformFilterComponent,
        TplValbaraMottagningsplatserFilterComponent
    ],
    exports: [SokTransportforetagComponent]
})
export class TransportModule {}
